<!-- 专题顶部banner -->
<template>
 <div class="banner" ref="banner">
    <div class="pc-banenr" :style="{'background-image':'url('+banner.pcBannerBg+')'}">
        
        <img :src="banner.pcBanner" class="" alt="">
    </div>
    <div class="media-banner "><img :src="banner.mBanner" alt=""></div>
</div>   
</template>
<script>
export default {
    name:'TopBanner',
    props:{
        banner:{
            pcBanner:'',
            pcBannerBg:'',
            mBanner:'',
        }
    }
}
</script>
<style lang="less" scoped>
.pc-banenr{display: none;}
.media-banner {display: block;}
@media screen and (min-width:768px){
    .pc-banenr{display: block; background-position:center top ;
        img{display: block; margin:0 auto}
    }
    .media-banner {display: none;}
}
</style>